import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import {DefaultTooltipContent} from "recharts/lib/component/DefaultTooltipContent";
import {
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Brush,
  Bar
} from "recharts";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  paper: theme.chartPaper,
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1
  }
}));

const SaleDesignerChartTotal = ({ data }) => {
  const classes = useStyles();

  const CustomTooltip = props => {
    if (!props.active) {
      return null;
    }

    const round = (n, k) => {
      const factor = Math.pow(10, k + 1);
      n = Math.round(Math.round(n * factor) / 10);
      return n / (factor / 10);
    };

    const newPayload = [
      {
        name: "Średnia cena",
        value: round(props.payload[0].payload.avgPriceNetto, 2)
      }
    ];

    return <DefaultTooltipContent {...props} payload={newPayload} />;
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="h2">Średnia sprzedaży netto PLN</Typography>
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <BarChart
              data={data}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="nazwa" />
              <YAxis dataKey="avgPriceNetto" />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip content={<CustomTooltip />} />
              <Legend
                payload={[
                  {
                    value: "Średnia cena sprzedaży netto",
                    type: "square",
                    color: "#112E51"
                  }
                ]}
              />
              <Bar dataKey="avgPriceNetto" fill="#8884d8" />
              <Brush dataKey="avgPriceNetto" height={30} stroke="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Paper>
    </div>
  );
};

export default SaleDesignerChartTotal;
